/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
var BootstrapTypes = {
  styles: {
    all: ['default', 'primary', 'success', 'info', 'warning', 'danger', 'link', 'primary-refined'],
    "default": 'default'
  },
  sizes: {
    all: ['xs', 'sm', 'md', 'lg', 'xl'],
    buttons: ['xs', 'sm', 'lg', undefined]
  },
  positions: {
    navbar: ['static-top', 'fixed-top', 'fixed-bottom', undefined]
  },
  floats: ['left', 'right', undefined]
};
export default BootstrapTypes;